var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6182 11.1284C16.1539 10.0084 17.1539 8.19581 17.1539 6.15384C17.1539 2.76061 14.3933 0 11.0001 0C7.60685 0 4.84624 2.76061 4.84624 6.15384C4.84624 8.19581 5.84622 10.0084 7.38194 11.1284C3.56444 12.5892 0.846252 16.2905 0.846252 20.6154C0.846252 22.4817 2.36458 24 4.23086 24H17.7693C19.6356 24 21.1539 22.4817 21.1539 20.6154C21.1539 16.2905 18.4357 12.5892 14.6182 11.1284ZM6.69241 6.15384C6.69241 3.77859 8.62483 1.84617 11.0001 1.84617C13.3753 1.84617 15.3078 3.77859 15.3078 6.15384C15.3078 8.52909 13.3753 10.4616 11.0001 10.4616C8.62483 10.4616 6.69241 8.52909 6.69241 6.15384ZM17.7693 22.1538H4.23086C3.38257 22.1538 2.69242 21.4637 2.69242 20.6153C2.69242 16.0344 6.41918 12.3076 11.0001 12.3076C15.5811 12.3076 19.3078 16.0344 19.3078 20.6153C19.3078 21.4637 18.6176 22.1538 17.7693 22.1538Z",
    fill: "#555555"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.59ded4b0.svg";
export { ForwardRef as ReactComponent };